import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_HOST } from 'consts';
import Card from 'components/Card';
import ClassConfirmationActions from './ClassConfirmationActions';

const DetalhesPage = ({ cards, ...rest }) => {
  const { id } = useParams();
  const [turma, setTurma] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchturma = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_HOST}/academico/status_confirmacao/${id}/get_turma`
        );
        setTurma(response.data);
      } catch (error) {
        console.error('Erro ao buscar turma', error);
        setTurma(null);
      } finally {
        setLoading(false);
      }
    };

    fetchturma();
  }, [id]);

  if (loading) {
    return <p>Carregando...</p>;
  }

  if (!turma) {
    return <p>Dados da turma não encontrados.</p>;
  }

  return (
    <Card title="Detalhes da Turma">
      <div className="mb-3" />
      <div className="d-flex align-items-center mb-4">
        <ClassConfirmationActions id={id} />
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <strong>Nome:</strong> {turma.name}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Currículo:</strong> {turma.curriculum}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Turma Pai:</strong> {turma.parent_class}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Validade (Início):</strong> {turma.validity_start_date}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Validade (Fim):</strong> {turma.validity_end_date}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Status de Validade:</strong> {turma.validity_status}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Quantidade de Egressos:</strong> {turma.quantidade_egressos}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Quantidade de Vagas:</strong> {turma.quantidade_vagas}
        </div>
        <div className="col-md-6 mb-3">
          <strong>Status Confirmação:</strong> {turma.status_confirmacao}
        </div>
      </div>
    </Card>
  );
};

export default DetalhesPage;
